/** These identifiers can be looked up in the ATIPDDisplayName table */
export const ArticleTechnicalInfoPropertyDef = {
  GRID_DIMENSIONS_FROM: '7',
  GRID_DIMENSIONS: '3992',
  MODULETYPE: '100000000',
  MOUNTING_TYPE: '100000001',
  OTHER: '100000002',
  COLOR: '2',
  SOLDERPINLAYOUT: '3976',
  SOLDERPINLENGTH: '122',
  ACTUATION_TYPE: '3901',
  ACTUATION_TYPE_2: '3902',
  NO_OF_POLES: '6',
  NO_OF_POTENTIALS: '5',
  CROSS_SECTION_FROM_1_MM: '20',
  CROSS_SECTION_UP_TO_1_MM: '21',
  CROSS_SECTION_FROM_1_AWG: '22',
  CROSS_SECTION_UP_TO_1_AWG: '23',
  CROSS_SECTION_RANGE: '2667',
  SOLDER_PIN_ARRANGEMENT: '3976',
  MAIN_PRODUCT_FUNCTION: '5200',
  POTENTIAL_MARKING: '7120',
  TOTAL_NUMBER_OF_CONNECTION_POINTS: '4',
  WIDTH: '60',
  TYPE_OF_MODULE: '100000000',
  NOMINAL_CROSS_SECTION: '3637',
  WEIGHT: '1',
  OPERATION_AMBIENT_TEMPERATURE: '10088',
  COMMUNICATION_OR_FIELDBUS: '7558',
  PRODUCT_TYPE: '7845',
  TOTAL_NUMBER_OF_CHANNELS: '7177',
  PLUGGABLE_CONNECTOR: '7762',
  SENSOR_CONNECTION_1: '7542',
  SENSOR_CONNECTION_2: '7543',
  SENSOR_CONNECTION_3: '7544',
  RESOLUTION: '1022',
  SIGNAL_TYPE_CURRENT: '10353',
  SIGNAL_TYPE_VOLTAGE: '10354',
  OUTPUT_CURRENT_PER_CHANNEL: '7194',
  SIGNAL_CHARACTERISTIC: '7185',
  ACTUATOR_CONNECTION_1: '7329',
  ACTUATOR_CONNECTION_2: '10358',
  ACTUATOR_CONNECTION_3: '10359',
  NUMBER_OF_CONNECTIONS: '25013',
} as const;

export type ArticleTechnicalInfoPropertyKey = keyof typeof ArticleTechnicalInfoPropertyDef;
export type ArticleTechnicalInfoPropertyValue = typeof ArticleTechnicalInfoPropertyDef[keyof typeof ArticleTechnicalInfoPropertyDef];

export const ArticleTechnicalInfoPropertyListDef = {
  SENSOR_CONNECTION: [
    ArticleTechnicalInfoPropertyDef.SENSOR_CONNECTION_1,
    ArticleTechnicalInfoPropertyDef.SENSOR_CONNECTION_2,
    ArticleTechnicalInfoPropertyDef.SENSOR_CONNECTION_3,
  ] as const,

  ACTUATOR_CONNECTION: [
    ArticleTechnicalInfoPropertyDef.ACTUATOR_CONNECTION_1,
    ArticleTechnicalInfoPropertyDef.ACTUATOR_CONNECTION_2,
    ArticleTechnicalInfoPropertyDef.ACTUATOR_CONNECTION_3,
  ] as const,
} as const;
